// extracted by mini-css-extract-plugin
module.exports = {"container":"button-icon_container__3bHd4","icon":"button-icon_icon__3ijpf","loading":"button-icon_loading__28XpE","label":"button-icon_label__jNnwE"};